import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { collection, getDocs, updateDoc, doc, addDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';
import moment from 'moment';

function Wallet() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });

    const [userData, setUserData] = useState(null);
    const [whatsappCount, setwhatsappCount] = useState(0);
    const [whatsappHist, setwhatsappHist] = useState([]);
    const [emailCount, setemailCount] = useState(0);
    const [smsCount, setsmsCount] = useState(0);
    const [countPaid, setcountPaid] = useState(0);
    const [walletDocId, setWalletDocId] = useState(null);

    // ✅ Watch auth state
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUserData(user);
            } else {
                setUserData(null);
            }
        });
        return () => unsubscribe();
    }, []);

    // ✅ Fetch data only when userData is available
    useEffect(() => {
        if (userData) {
            fetchData1();
        }
    }, [userData]);

    const fetchData1 = async () => {
        try {
            // WhatsApp history
            const snapshot = await getDocs(collection(db, 'whatsapphistory'));
            const historyData = snapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    createdAt: data.createdAt?.toDate
                        ? data.createdAt.toDate()
                        : new Date(data.createdAt)
                };
            });

            historyData.sort((a, b) => b.createdAt - a.createdAt);
            setwhatsappCount(snapshot.size);
            setwhatsappHist(historyData);

            // Wallet doc
            const walletSnapshot = await getDocs(collection(db, 'whatsapp'));
            if (!walletSnapshot.empty) {
                const walletDoc = walletSnapshot.docs[0];
                setcountPaid(walletDoc.data().countpaid || 0);
                setWalletDocId(walletDoc.id);
            } else {
                const newWalletRef = await addDoc(collection(db, 'whatsapp'), {
                    countpaid: 0,
                    createdAt: new Date()
                });
                setcountPaid(0);
                setWalletDocId(newWalletRef.id);
            }

            // Dummy values
            setemailCount(0);
            setsmsCount(0);

        } catch (error) {
            Toast.fire({ icon: 'error', title: error.message });
            console.error(error);
        }
    };

    // ✅ Update countPaid
    const handleUpdateCountPaid = async () => {
        if (!walletDocId) {
            Toast.fire({ icon: 'error', title: 'Wallet document not found!' });
            return;
        }

        const { value: newCount } = await Swal.fire({
            title: 'Update Count Paid',
            input: 'number',
            inputValue: countPaid,
            inputLabel: 'Enter new count paid',
            inputPlaceholder: 'Enter number',
            showCancelButton: true,
            confirmButtonText: 'Update',
            cancelButtonText: 'Cancel'
        });

        if (newCount !== undefined) {
            try {
                const walletRef = doc(db, 'whatsapp', walletDocId);
                await updateDoc(walletRef, { countpaid: Number(newCount) });
                setcountPaid(Number(newCount));
                Toast.fire({ icon: 'success', title: 'Count Paid updated!' });
            } catch (err) {
                Toast.fire({ icon: 'error', title: err.message });
            }
        }
    };

    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff', minHeight: '100vh' }}>
                <section className="content"><br />
                    <div className="container-fluid">
                        <button className="btn btn-secondary mb-3">|| Wallet ||</button>

                        {/* Count Boxes */}
                        <div className="row">
                            <div className="col-md-4 mb-4">
                                <div className="card text-center shadow-lg border-0 rounded-4 overflow-hidden">
                                    <div className="card-header bg-success text-white fw-bold text-uppercase d-flex justify-content-between align-items-center">
                                        WhatsApp
                                        <button className="btn btn-sm btn-light" onClick={handleUpdateCountPaid}>
                                            Update Paid
                                        </button>
                                    </div>
                                    <div className="card-body">
                                        <h3 className="text-success fw-bold">
                                            ₹ {(whatsappCount - countPaid) * 1.50}
                                        </h3>
                                        <button className="btn btn-outline-success mt-3 px-4 py-2 rounded-pill">
                                            <i className='fa fa-whatsapp'></i> {whatsappCount - countPaid}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 mb-4">
                                <div className="card text-center shadow-lg border-0 rounded-4 overflow-hidden">
                                    <div className="card-header bg-warning text-white fw-bold text-uppercase">
                                        Email
                                    </div>
                                    <div className="card-body">
                                        <h3 className="text-warning fw-bold">{emailCount}</h3>
                                        <button className="btn btn-outline-warning mt-3 px-4 py-2 rounded-pill">
                                            <i className='fa fa-envelope'></i> {emailCount}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 mb-4">
                                <div className="card text-center shadow-lg border-0 rounded-4 overflow-hidden">
                                    <div className="card-header bg-primary text-white fw-bold text-uppercase">
                                        SMS
                                    </div>
                                    <div className="card-body">
                                        <h3 className="text-info fw-bold">{smsCount}</h3>
                                        <button className="btn btn-outline-primary mt-3 px-4 py-2 rounded-pill">
                                            <i className='fa fa-comment'></i> {smsCount}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* History Table */}
                        <div className="row">
                            <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover table-striped">
                                        <thead className="thead-dark">
                                            <tr>
                                                <th>Sr No</th>
                                                <th>Created At</th>
                                                <th>Customer</th>
                                                <th>Mobile</th>
                                                <th>Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {whatsappHist.length > 0 ? (
                                                whatsappHist.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{moment(item.createdAt).format('MMM DD, YYYY hh:mm:ss A')}</td>
                                                        <td>{item.custname || '-'}</td>
                                                        <td>{item.mobile || '-'}</td>
                                                        <td>{item.type || '-'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No history found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </div>
    );
}

export default Wallet;
